export { useGetRecommendedUpNext } from './RecommendationService'
export type { RecommendedUpNextContent, RecommendedUpNextResult } from './types'
